import React from 'react';
import { Link } from 'library/util/core-router';
import PropTypes from 'prop-types';
import withData from 'util/hoc/with-data';
import {
  GetUserData,
  HasEducation,
  HasWorkExperience,
  HasSurveyData,
  HasSkills,
  HasInterests
} from 'apps/pathways/services/pathway';

class ImproveResults extends React.Component {
  static propTypes = {
    graph_loading: PropTypes.bool,
    graph_data: PropTypes.object
  }

  render() {
    const {
      graph_loading,
      graph_data
    } = this.props;

    if (graph_loading) {
      return null;
    }

    if (!HasEducation(graph_data)) {
      return (
        <div>
          Improve results: <Link to="/pathways/start/1">add education</Link>
        </div>
      );
    }

    if (!HasWorkExperience(graph_data)) {
      return (
        <div>
          Improve results: <Link to="/pathways/start/1">add work experience</Link>
        </div>
      );
    }

    if (!HasSurveyData(graph_data)) {
      return (
        <div>
          Improve results: <Link to="/pathways/start/2">take the PAIRIN survey</Link>
        </div>
      );
    }

    if (!HasInterests(graph_data)) {
      return (
        <div>
          Improve results: <Link to="/pathways/start/3">complete the interest survey</Link>
        </div>
      );
    }

    if (!HasSkills(graph_data)) {
      return (
        <div>
          Improve results: <Link to="/pathways/start/1">add skills</Link>
        </div>
      );
    }

    return null;
  }
}

ImproveResults.query = async () => {
  return {
    data: await GetUserData()
  };
};

export default withData(ImproveResults);
